<template>
  <el-select
    ref="servicesgroup"
    v-model="selected"
    clearable
    filterable
    :placeholder="$t('selecione-uma-opcao')"
    @change="update()"
  >
    <el-option
      v-for="row of servicesgroup"
      :key="row.id"
      :label="`${row.name} (${row.code})`"
      :value="row.id"
    ></el-option>
  </el-select>
</template>

<script>
import { ServicesGroupService } from "@/services/customers/services.group.services";
export default {
  name: "ServicesGroupList",
  data: function () {
    return {
      servicesgroup: [],
      selected: "",
    };
  },
  props: {
    current: String,
  },
  methods: {
    fetchServices() {
      const vm = this;
      ServicesGroupService.list()
        .then((response) => {
          vm.servicesgroup = response.records;
          setTimeout(() => {
            if (vm.$props.current) {
              vm.selected = vm.$props.current;
            }
          }, 500);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetchServices();
  },
};
</script>